import _isEqual from 'lodash/isEqual';
import { getVerticalNav, HOME } from '#/utils/navigationHelper';
import { hex2rgba } from '#/utils/hex2rgba';
import { containersTypeAlias } from '#/config/constants';
import { isWorkstation } from '#/utils/componentStyleConfig';
import { onVideoTileClick } from '#/components/Swimlane/utils';

import homeOverlayBg from '#/static/images/background-images/HomeBgGradation.png';

const { CAROUSEL_CONTAINER } = HOME;
let videoToPlay = null;

export const getAgeGradient = ageMetadata => {
  const { colorScheme } = ageMetadata ?? {};

  if (!colorScheme) {
    return '';
  }

  const { backgroundPrimary } = colorScheme;

  // Force enables background video playback
  // TODO: Pull this value from control, maybe isBackgroundVideoEnabled
  // eslint-disable-next-line no-constant-condition
  if (false) {
    return hex2rgba(backgroundPrimary);
  }

  // TODO: Make sure that we don't need different images depending on color scheme
  if (!isWorkstation()) {
    return `url(${homeOverlayBg})`;
  }

  return `linear-gradient(180deg, rgba(0,0,0,0) 0%,
    ${hex2rgba(backgroundPrimary, 0.1)} 30%,
    ${hex2rgba(backgroundPrimary)} 55%
  )`;
};

export const getOvpContainerIds = containers => {
  const totalContainers = containers.length;
  const ids = [];

  for (let i = 0; i < totalContainers; i += 1) {
    const { _meta } = containers[i];

    if (_meta.typeAlias === containersTypeAlias.CONTAINER_OVP_PLAYLIST) {
      ids.push(_meta.id);
    }
  }

  return ids;
};

let bcContainerItems = null;

export const getCachedBcContainerItems = newItems => {
  if (_isEqual(bcContainerItems, newItems)) {
    return bcContainerItems;
  }

  bcContainerItems = newItems;

  return bcContainerItems;
};

export const getContainersWithData = (containers, bcContainersData) => {
  const totalContainers = containers.length;
  const containersWithData = [];

  for (let i = 0; i < totalContainers; i += 1) {
    const id = containers[i]?._meta?.id;
    const data = bcContainersData[id] !== undefined && bcContainersData[id];

    if (data.length > 0) {
      containersWithData.push(id);
    }
  }

  return containersWithData;
};

export const getNavIds = (containers, containersWithData) => {
  if (!containers.length) {
    return {};
  }

  const defaultNav = getVerticalNav(
    containers?.map(carousel => `id-${carousel._meta.id}`),
    {
      parent: CAROUSEL_CONTAINER,
    },
  );

  // to ensure that we only add navs to containers with content available
  if (containersWithData?.length && !isWorkstation()) {
    const containersForNavs = containers
      .filter(
        item =>
          containersWithData.indexOf(item._meta.id) > -1 ||
          (item.fsCollectionName &&
            !item.fsCollectionName.includes('podcast') &&
            item._meta.typeAlias !== containersTypeAlias.CONTAINER_HERO),
      )
      .map(item => `id-${item?._meta?.id}`);

    const tvNavOverride = getVerticalNav(containersForNavs, {
      parent: CAROUSEL_CONTAINER,
    });
    return tvNavOverride;
  }
  return defaultNav;
};

export const getOnVideoTileClickContainers = (containers, dispatch) => {
  return containers
    .filter(
      item =>
        item._meta.typeAlias === containersTypeAlias.CONTAINER_OVP_PLAYLIST,
    )
    .reduce((obj, { _meta }) => {
      return {
        ...obj,
        [_meta.id]: onVideoTileClick([_meta.id], dispatch, true, true)(0),
      };
    }, {});
};

export const setInitialVideoData = (
  playlists,
  currentPlaylistIndex,
  currentVideoIndex,
  currentVideo,
  initiation,
) => {
  videoToPlay = {
    playlists,
    currentPlaylistIndex,
    currentVideoIndex,
    currentVideo,
    initiation,
  };
};

export const getInitialVideoData = () => {
  return videoToPlay;
};

export const clearInitialVideoData = () => {
  videoToPlay = null;
};
